import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';

const TimeSelectorButton = React.forwardRef((props, ref) => {
  const { status, timeslot, showTime, showIcon, access } = props;

  const btnClass = classNames('time-selector__button', {
    'time-selector__button--available':
      status === 'Available' || status === true,
    'time-selector__button--restricted':
      status === 'Restricted' || status === false,
    'time-selector__button--lockboxRestricted':
      (status === 'Restricted' || status === false) &&
      access === 'Supra Lockbox',
    'time-selector__button--autoConfirm': status === 'AutoConfirm',
    'time-selector__button--noLockbox': status === 'noLockbox',
  });

  let content;
  if (showTime) {
    content = moment(timeslot, 'H:mm').format('h:mm a');
  } else if (typeof status === 'boolean') {
    content = status
      ? 'Available'
      : access === 'Supra Lockbox'
        ? ['Showing', <br />, 'Restricted']
        : 'Restricted';
  } else if (status === 'AutoConfirm') {
    content = 'Auto Conf';
  } else if (status === 'Restricted') {
    content =
      access === 'Supra Lockbox'
        ? [`Showing`, <br />, `Restricted`]
        : 'Restricted';
  } else if (status === 'noLockbox') {
    content = [`Lockbox`, <br />, `Restricted`];
  } else {
    content = status;
  }

  // TODO: Reimplement this as a button for a11y purposes e.g. keyboard navigation
  return (
    <div className={btnClass} ref={ref}>
      {showIcon && (
        <i
          className={classNames({
            'time-selector__button-icon fa fa-check':
              status === true ||
              status === 'Available' ||
              status === 'AutoConfirm',
            'time-selector__button-icon fa fa-times':
              status === false ||
              status === 'Restricted' ||
              status === 'noLockbox',
          })}
        />
      )}
      <span className="time-selector__button-text">{content}</span>
    </div>
  );
});

TimeSelectorButton.propTypes = {
  timeslot: PropTypes.string,
  showTime: PropTypes.bool,
  showIcon: PropTypes.bool,
};

TimeSelectorButton.defaultProps = {
  showTime: false,
  showIcon: false,
};

export default TimeSelectorButton;
